import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";

const Section = styled.div`
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  padding: 45px 20px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    flex-grow: 0;
    flex-shrink: 0;
  }

  ${media.tablet`
    padding: 35px 20px;
    display: block;
    
    h2 {
      margin-bottom: 30px;
      padding-right: 50px;
      position: relative;
      
      &:after {
        content: '';
        position: absolute;
        height: 2px;
        width: 40px;
        background-color: #333;
        bottom: 14px;
        right: 0;
      }
    }
  `};
`;

const ShareLine = styled.span`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 2px;
  background-color: #999;
  margin: 0 20px;

  ${media.tablet`
    display: none;
  `};
`;

const Share = styled.ul`
  flex-grow: 0;
  flex-shrink: 0;

  li {
    margin: 0 10px 0 0;
    display: inline-block;

    &:last-child {
      margin: 0;
    }

    &:hover,
    &:focus {
      a:before {
        color: #e1171e;
      }
    }
  }

  a {
    position: relative;

    &:last-child {
      margin: 0;
    }

    &:before {
      font-family: "Iconfont" !important;
      content: "\\e900";
      font-size: 24px;
      color: #999;
      transition: color 0.3s ease-in-out;
    }

    &.li {
      &:before {
        content: "\\e905";
      }
    }

    &.ig {
      &:before {
        content: "\\e904";
      }
    }

    &.fb {
      &:before {
        content: "\\e902";
      }
    }

    &.tw {
      &:before {
        content: "\\e906";
      }
    }

    &.ma {
      &:before {
        content: "\\e910";
      }
    }

    &.wh {
      &:before {
        content: "\\e90f";
      }
    }
  }

  ${media.tablet`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    
    li {
      margin: 0 10px;
      
      &:last-child {
        margin: 0 10px;
        
        a:before {
          margin-top: 0;
        }
      }
      
      &:hover,
      &:focus {
        a:before {
          color: #999;
        }
      }
    }
  `};
`;

export class JobShare extends React.Component {
  render() {
    let link = this.props.link;
    let title = this.props.title;

    return (
      <Section>
        <Container>
          {this.props.type === "event" ? (
            <h2>Share this event with someone else</h2>
          ) : (
            <h2>Share this position with someone else</h2>
          )}

          <ShareLine />

          <Share className={"no-list"}>
            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon li"}
                target={"_blank"}
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${link}`}
              />
            </li>

            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon fb"}
                target={"_blank"}
                href={`http://www.facebook.com/sharer/sharer.php?u=${link}`}
              />
            </li>

            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon tw"}
                target={"_blank"}
                href={`http://twitter.com/share?text=${title};&url=${link};`}
              />
            </li>

            <li>
              {/* eslint-disable-next-line */}
              <a className={"icon ma"} href={`mailto:?body=${link}`} />
            </li>

            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon wh"}
                target={"_blank"}
                href={`https://wa.me/?text=${link}`}
              />
            </li>
          </Share>
        </Container>
      </Section>
    );
  }
}
